<div [ngClass]="{ loading: showLoader }">
  <div class="scrollable-wrap" id="NWMTable_{{NWMTableID}}">
    <div class="scrollable">
      <div class="scrollable-button left"></div>
      <div class="scrollable-button"></div>

      <table class="NWMtable table-sortable">
        <ng-container *ngTemplateOutlet="thead" />
        @if (!data || data.Items.length === 0) {
          <tbody>
            <tr>
              <td [attr.colspan]="options!.columns.length" align="center"><i>No records found.</i></td>
            </tr>
          </tbody>
        }
        @if (data && data.Items.length > 0) {
          <tbody>
            @for (item of data.Items; track item; let j = $index) {
              <tr [ngbTooltip]="options?.tooltipField ? asString(item[options!.tooltipField]) : ''" placement="top">
                @for (col of options!.columns; track col; let i = $index) {
                  <td [class]="col.class ? col.class : ''" (click)="rowClick(item, i)">{{formattedData[j][i]}}</td>
                }
              </tr>
            }
          </tbody>
        }
      </table>
      @if (data && data.TotalItems > options!.request.PageSize) {
        <div class="mt-3">
          <ngb-pagination [collectionSize]="data.TotalItems"
            [(page)]="options!.request.Page" [maxSize]="5" (pageChange)="gotoPage($event)"
            class="float-right pagination"
            [boundaryLinks]="true"
            [pageSize]="options!.request.PageSize"
            [attr.data-scrollTo]="'#NWMTable_'+NWMTableID" />
          </div>
        }
        <div class="sticky_header_clone" style="display:none">
          <table class="NWMtable table-sortable">
            <ng-container *ngTemplateOutlet="thead" />
          </table>
        </div>
      </div>
    </div>
  </div>

  <ng-template #thead>
    <thead>
      <tr>
        @for (col of options!.columns; track col) {
          <td (click)="sort(col)" [ngClass]="{'sorted-asc' : (sortBy === col.field) && asc,'sorted-desc' : (sortBy === col.field) && !asc, 'not-sortable' : col.notSortable}" [class]="col.class ? col.class : ''"><span>{{col.title}}</span></td>
        }
      </tr>
    </thead>
  </ng-template>
